import React from 'react';
import { ContentRecommendationsSettings } from '../../models/tcsm-block-models';
import { renderMustache } from '../content-recommendations/mustache-lite';
import {
    useContentRecommendations,
    useIdioTracker,
    DEFAULT_IDIO_CLIENT_NAME,
} from '../content-recommendations/use-content-recommendations';

// Accepts the settings subset so the view can also render placements nested in
// other blocks (e.g. related links carousel slides), not just top-level blocks.
interface Props {
    blockData: ContentRecommendationsSettings,
}

// Optimizely Content Recommendations block. The MVC site lets ip.js render the
// block's mustache template on page load; that never fires for React-rendered
// content, so this view calls the same delivery API and renders the CMS-authored
// template itself. All three delivery template variants work unchanged.
export const ContentRecommendationsBlockView = (props: Props) => {

    const { blockData } = props;

    useIdioTracker(DEFAULT_IDIO_CLIENT_NAME);

    const { items, loading, error } = useContentRecommendations(
        blockData?.deliveryApiKey,
        blockData?.numberOfRecommendations || 3,
    );

    if (loading || error || !items.length || !blockData?.recommendationsTemplate) {
        return null;
    }

    return (
        <div
            className='idio-recommendations'
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: renderMustache(blockData.recommendationsTemplate, { content: items }) }}
        />
    );

};

export default ContentRecommendationsBlockView;
